import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CompaniesFilterDialogComponent } from 'src/app/companies/companies-filter-dialog/companies-filter-dialog.component';
import { ListArchivedCompaniesParams } from 'src/app/core/companies.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';

@Component({
  selector: 'app-archived-companies-filter-dialog',
  templateUrl: './archived-companies-filter-dialog.component.html',
  styleUrls: ['./archived-companies-filter-dialog.component.scss'],
})
export class ArchivedCompaniesFilterDialogComponent {
  archived_companies_filters_from_group: FormGroup = this.form_service.archived_companies_filters_from_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  is_list_running: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<CompaniesFilterDialogComponent>,
    private form_service: FormService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {}

  ngOnInit(): void {}

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onApplyFiltersClick(): void {
    if (this.isFormValid()) {
      const company_id: string = this.archived_companies_filters_from_group.get(
        this.form_service.company_id_label,
      )?.value;
      const business_name: string = this.archived_companies_filters_from_group.get(
        this.form_service.business_name_label,
      )?.value;
      const vat: string = this.archived_companies_filters_from_group.get(this.form_service.vat_label)?.value;
      const params: ListArchivedCompaniesParams = {
        company_id: company_id == '' ? undefined : company_id,
        business_name: business_name == '' ? undefined : business_name,
        vat: vat == '' ? undefined : vat,
      };
      this.dialog_ref.close({ params });
    }
  }

  onClearFiltersClick(): void {
    this.archived_companies_filters_from_group.reset();
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.archived_companies_filters_from_group);
  }
}
